import ContactUs from "layouts/contactus";
import BrandToolKit from "layouts/brandtoolkit";

// @mui icons
import Icon from "@mui/material/Icon";


const routes = [
    {
        name: "user_data",
        type: "collapse",
        key: "user_data",
        route: "/profile",
        noCollapse: true,
    },
    { type: "divider", key: "divider-0" },
    {
        type: "collapse",
        name: "Dashboard",
        key: "dashboard",
        icon: <Icon fontSize="medium">home</Icon>,
        route:"/dashboard",
        noCollapse: true,
    },
    { type: "title", title: "My Referrals", key: "my-referrals" },
    {
        type: "collapse",
        name: "Active",
        key: "active",
        icon: <Icon fontSize="medium">active</Icon>,
        collapse: [
            { name: "Pending", key: "pending", route: "/referral/active/pending"},
            { name: "Overdue", key: "overdue", route: "/referral/active/overdue"},
            { name: "All Active", key: "allactive", route: "/referral/active/allactive"},
            { name: "Prospects", key: "prospects", route: "/referral/active/prospects" },
            { name: "Clients", key: "clients", route: "/referral/active/clients" },
            { name: "Under Contract", key: "undercontract", route: "/referral/active/undercontract" },
            { name: "Nurture", key: "nurture", route: "/referral/active/nurture" },
        ],
    },
    {
        type: "collapse",
        name: "Not Active",
        key: "notactive",
        icon: <Icon fontSize="medium">not-active</Icon>,
        collapse: [
            { name: "Closed", key: "closed", route: "/referral/not-active/closed" },
            { name: "Cancelled", key: "cancelled", route: "/referral/not-active/cancelled" },
        ],
    },

    { type: "title", title: "OutBound Referrals", key: "outboundreferrals" },
    {
        type: "collapse",
        name: "Active",
        key: "outbound-active",
        icon: <Icon fontSize="medium">active</Icon>,
        collapse: [
            { name: "Prospects", key: "outbound-prospects", route: "/out-bound/active/prospects" },
            { name: "Clients", key: "outbound-clients", route: "/out-bound/active/clients" },
            { name: "Under Contract", key: "outbound-undercontract", route: "/out-bound/active/under-contract" },
            { name: "Nurture", key: "outbound-nurture", route: "/out-bound/active/nurture" },
        ],
    },
    {
        type: "collapse",
        name: "Not Active",
        key: "outbound-notactive",
        icon: <Icon fontSize="medium">not-active</Icon>,
        collapse: [
            { name: "Closed", key: "outbound-closed", route: "/out-bound/not-active/closed" },
            { name: "Cancelled", key: "outbound-cancelled", route: "/out-bound/not-active/cancelled" },
        ],
    },

    { type: "divider", key: "divider-1" },
    { type: "title", title: "Influencer Resources", key: "resources" },
    
    {
        type: "collapse",
        name: "Brand Toolkit",
        key: "BrandToolKit",
        icon: <Icon fontSize="medium">contactus</Icon>,
        route:"/brandtoolkit",
        component: <BrandToolKit />,
        noCollapse: true,
    },
    {
        type: "collapse",
        name: "Tips & Guides",
        key: "TipsAndGuides",
        icon: <Icon fontSize="medium">active</Icon>,
        collapse: [
            { name: "Portal Walkthrough", key: "Portal Walkthrough", route: "/portal/walkthrough" },
        ],
    },
    {
        type: "collapse",
        name: "Contact Us",
        key: "Influencer contactus",
        icon: <Icon fontSize="medium">contactus</Icon>,
        route:"/contactus",
        component: <ContactUs />,
        noCollapse: true,
    },

    { type: "divider", key: "divider-agent" },
    { type: "title", title: "Agent Resources", key: "agent resources" },
    {
        type: "collapse",
        name: "Agent FAQs",
        key: "agentfaqs",
        href: "https://www.myagentfinder.com/faq",
        icon: <Icon fontSize="medium">faqs</Icon>,
        noCollapse: true,
    },
    {
        type: "collapse",
        name: "Report Multiple Transaction",
        key: "duplicate",
        icon: <Icon fontSize="medium">contactus</Icon>,
        route:"/reportduplicate",
        noCollapse: true,
    },
    {
        type: "collapse",
        name: "Additional Resources",
        key: "Resources",
        icon: <Icon fontSize="medium">active</Icon>,
        collapse: [
            { name: "Status Updates", key: "statusupdates", href: "https://www.loom.com/share/e7a1dad60a76448ebc9761eedc7d9269?sid=05d2ba3b-c319-4803-bbb6-48a6ceac26a7" },
            { name: "Status Update How To: Assigned & Nurture", key: "statusupdates-assigned-nurture", href: "https://www.loom.com/share/41e32cfb43514796805201d60109fc7a" },
            { name: "Status Update How To: Client Stage", key: "statusupdates-client", href: "https://www.loom.com/share/2bdcd7716bcc4db48eceb7eec1e7c97f" },
            { name: "Status Update How To: Prospect Stage", key: "statusupdates-prospect", href: "https://www.loom.com/share/b588e94596074ae78377c8d97d6a7234" },
        ],
    },
    {
        type: "collapse",
        name: "Referral Terms",
        key: "referralterms",
        href: "/agree",
        icon: <Icon fontSize="medium">terms</Icon>,
        noCollapse: true,
    },    {
        type: "collapse",
        name: "W-9 Form",
        key: "w-9form",
        href: "https://drive.google.com/file/d/1SDTAsyaj_g5qiL75PS5V_aCaY-VveN-h/view?usp=sharing",
        icon: <Icon fontSize="medium">w9form</Icon>,
        noCollapse: true,
    },    {
        type: "collapse",
        name: "Contact Us",
        key: "contactus",
        icon: <Icon fontSize="medium">contactus</Icon>,
        route:"/contact",
        noCollapse: true,
    },

];

export default routes;
